@if(!isSingleDate){
  <div class="date-time-input-wrapper">
    <mat-form-field>
      <input class="mat-date-range-input-inner pushInput" id="date-range-input" matInput matTooltipPosition="above"
             placeholder="MM/DD/YYYY - MM/DD/YYYY" readonly [attr.aria-labelledby]="'date-range-label'"
             [attr.data-pw]="`${dataPwPrefix}-date-input`" [attr.data-qa]="`${dataQaPrefix}-date-input`"
             [matTooltip]="showToolTip ? displayDateValue : ''" [value]="displayDateValue" (click)="showPicker = true" />

      <!-- Calendar icon inside border -->
      <button mat-icon-button matSuffix (click)="showPicker = true">
        <mat-icon>date_range</mat-icon>
      </button>
    </mat-form-field>

    @if (showTime) {
      <mat-form-field>
        <input class="mat-date-range-input-inner pushInput" id="date-time-input" matInput matTooltipPosition="above"
               placeholder="AM - PM" readonly [attr.aria-labelledby]="'date-time-label'"
               [attr.data-pw]="`${dataPwPrefix}-time-input`" [attr.data-qa]="`${dataQaPrefix}-time-input`"
               [matTooltip]="showToolTip ? displayTimeValue : ''" [value]="displayTimeValue" (click)="showPicker = true"/>

        <!-- Calendar icon inside border -->
        <button mat-icon-button matSuffix (click)="showPicker = true">
          <mat-icon>schedule</mat-icon>
        </button>
      </mat-form-field>
    }
  </div>

  <!-- Date Range Picker Popup -->
  @if(showPicker) {
    <div class="picker-backdrop" (click)="cancel()" (keydown.enter)="cancel()"
         (keydown.space)="cancel(); $event.preventDefault()" tabindex="0" role="button" 
         aria-label="Close date picker">
    </div>
    <div class="picker-popup">
      <div class="range-picker-container" [class.disabled]="disabled">
        <div class="calendar-row">
          <!-- Start Date -->
          <mat-calendar #startCalendar class="range-calendar" [startAt]="leftCalendarMonth"
                        (selectedChange)="onDateSelected($event)" [dateClass]="dateClass"
                        [selected]="startDateObj" [minDate]="minDate"
                        [maxDate]="maxDate" [attr.data-pw]="`${dataPwPrefix}-start-calendar`"
                        [attr.data-qa]="`${dataQaPrefix}-start-calendar`">
          </mat-calendar>

          <!-- End Date -->
          <mat-calendar #endCalendar class="range-calendar" [startAt]="rightCalendarStart" [minDate]="minDate"
                        [maxDate]="maxDate" (selectedChange)="onDateSelected($event)" [dateClass]="dateClass" [selected]="endDateObj"
                        [attr.data-pw]="`${dataPwPrefix}-end-calendar`" [attr.data-qa]="`${dataQaPrefix}-end-calendar`">
          </mat-calendar>
        </div>

      @if (showTime) {
        <!-- Time Selection -->
        <div class="time-row">
          <mat-form-field appearance="outline" [attr.data-pw]="`${dataPwPrefix}-start-time-input`"
                          [attr.data-qa]="`${dataQaPrefix}-start-time-input`">
            <mat-select [(ngModel)]="startTime" placeholder="Start Time">
              @for (t of timeSlots;let i = $index; track t) {
                <mat-option [value]="t">{{ t }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" [attr.data-pw]="`${dataPwPrefix}-end-time-input`"
                          [attr.data-qa]="`${dataQaPrefix}-end-time-input`">
            <mat-select [(ngModel)]="endTime" placeholder="End Time">
              @for (t of timeSlots;let i = $index; track t) {
                <mat-option [value]="t">{{ t }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      @if (validationMessage) {
        <div class="validation-message" [attr.data-pw]="`${dataPwPrefix}-validation-message`"
            [attr.data-qa]="`${dataQaPrefix}-validation-message`">
          {{ validationMessage }}
        </div>
      }

      <!-- Actions -->
      <div class="action-row">
        <button mat-stroked-button (click)="cancel()" [disabled]="disabled">Cancel</button>
        <button mat-flat-button color="primary" (click)="applyDateAndTime()" [disabled]="disabled">Apply</button>
      </div>
    </div>
    </div>
  }
} @else {
  <div class="date-time-input-wrapper">
    <mat-form-field>
      <input id="single-date-input" matInput placeholder="MM/DD/YYYY" class="mat-date-range-input-inner pushInput" (click)="showPicker = true"
             [value]="displayDateValue" [attr.data-pw]="`${dataPwPrefix}-date-input`"
             [attr.data-qa]="`${dataQaPrefix}-date-input`" readonly [attr.aria-labelledby]="'single-date-label'" />

      <button mat-icon-button matSuffix (click)="showPicker = true">
        <mat-icon>date_range</mat-icon>
      </button>
    </mat-form-field>
    
    @if(showTime) {
      <mat-form-field>
        <input id="single-time-input" matInput placeholder="Time" class="mat-date-range-input-inner pushInput" (click)="showPicker = true"
               [value]="displayTimeValue" [attr.data-pw]="`${dataPwPrefix}-time-input`"
               [attr.data-qa]="`${dataQaPrefix}-time-input`" readonly [attr.aria-labelledby]="'single-time-label'" />

        <button mat-icon-button matSuffix (click)="showPicker = true">
          <mat-icon>schedule</mat-icon>
        </button>
      </mat-form-field>
    }
  </div>

  @if(showPicker) {
    <div class="picker-backdrop" (click)="cancel()" (keydown.enter)="cancel()"
         (keydown.space)="cancel(); $event.preventDefault()" tabindex="0" role="button" 
         aria-label="Close date picker">
    </div>
    <div class="picker-popup">
      <div class="range-picker-container" [class.disabled]="disabled">
        <div class="calendar-row">
          <mat-calendar #startCalendar class="range-calendar" [selected]="startDateObj" [startAt]="leftCalendarMonth"
                        (selectedChange)="onDateSelected($event)" [dateClass]="dateClass" [minDate]="minDate" [maxDate]="maxDate"
                        [attr.data-pw]="`${dataPwPrefix}-start-calendar`" [attr.data-qa]="`${dataQaPrefix}-start-calendar`">
          </mat-calendar>
        </div>

        <div class="time-row">
          <mat-form-field appearance="outline" [attr.data-pw]="`${dataPwPrefix}-start-time-input`"
                          [attr.data-qa]="`${dataQaPrefix}-start-time-input`">
            <mat-select [(ngModel)]="startTime" placeholder="Time">
              @for (t of timeSlots;let i = $index; track t) {
                <mat-option [value]="t">{{ t }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
    
        @if (validationMessage) {
          <div class="validation-message" [attr.data-pw]="`${dataPwPrefix}-validation-message`"
              [attr.data-qa]="`${dataQaPrefix}-validation-message`">
            {{ validationMessage }}
          </div>
        }

        <div class="action-row">
          <button mat-stroked-button (click)="cancel()" [disabled]="disabled">Cancel</button>
          <button mat-flat-button color="primary" (click)="applyDateAndTime()" [disabled]="disabled">Apply</button>
        </div>
      </div>
    </div>
  }
}